/*global jQuery*/
(function ($) {
    'use strict';

    var $quickLinks = $('.quick-links__link');

    $quickLinks.matchHeight();
}(jQuery));